import React, { memo, useRef, ReactElement } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, PlusCircle } from "react-feather";
import { Link, useNavigate, To } from "react-router-dom";
import ImageWithBasePath from "../component/ImageWithBasePath";
import GridTable from "../component/GridTable";
import StockReportTable from "./StockReportTable";

// Interface for the ref methods exposed by GridTable
interface GridTableRef {
  exportToExcel: () => void;
  exportToPDF: () => void;
}

// Type for GridTable props to help TypeScript understand its ref
type GridTableProps = React.ComponentPropsWithRef<typeof GridTable>;

interface WrapperProps {
  header?: string;
  subHeader?: string;
  onClick?: (e: React.MouseEvent) => void;
  children: React.ReactNode;
  addButton?: string;
  link?: string;
  linkState?: any;
  backLink?: string;
  backLinkState?: any;
  backButtonName?: string;
  props?: any;
  subheaderstyle?: any;
  DownloadPdf?: () => void;
  pdfLink?: string;
  ExportR?: number;
  importButtonName?: string;
  create?: boolean;
  handleImportClick?: () => void;
  extralink?: string;
}

const Wrapper = ({
  header,
  subHeader,
  onClick,
  children,
  addButton,
  link,
  linkState,
  backLink,
  backLinkState,
  backButtonName,
  props,
  subheaderstyle,
  DownloadPdf,
  pdfLink,
  ExportR,
  importButtonName,
  extralink,
}: WrapperProps) => {
  const tableRef = useRef<GridTableRef>(null);
  const navigate = useNavigate();

  const pathName = window.location.pathname;
  const basePath = pathName.split("/")[1] || "";

  console.log("Wrapper-Path", pathName);
  const containerClass =
    basePath === "RepList" ||
    basePath === "company" ||
    basePath === "V-10001" ||
    basePath === "order" ||
    basePath === "receipt"
      ? "container-fluid"
      : "page-wrapper";

  const hasGridTable = React.Children.toArray(children).some(
    (child) =>
      (React.isValidElement(child) && child.type === GridTable) ||
      (React.isValidElement(child) && child.type === StockReportTable)
  );

  const renderTooltip = (props: any) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props: any) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const handleExportPDF = (e: React.MouseEvent) => {
    e.preventDefault();
    if (tableRef.current) {
      console.log("Exporting PDF via tableRef");
      tableRef.current.exportToPDF();
    } else if (pdfLink && pdfLink.trim() !== "") {
      console.log("Opening PDF link:", pdfLink);
      window.open(pdfLink, "_blank", "noopener,noreferrer");
    } else if (DownloadPdf) {
      console.log("Calling DownloadPdf function");
      DownloadPdf();
    } else {
      console.warn("No PDF export method available");
    }
  };

  const handleExportCSV = (e: React.MouseEvent) => {
    e.preventDefault();
    if (tableRef.current) {
      console.log("Exporting Excel via tableRef");
      tableRef.current.exportToExcel();
    } else {
      console.warn("GridTable ref not available for CSV export");
    }
  };

  const handleClick = (e: React.MouseEvent) => {
    if (!link || link.trim() === "") {
      e.preventDefault();
      if (onClick) {
        onClick(e);
      }
    }
  };

  const handleBackClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (backLink && backLink.trim() !== "") {
      navigate(
        {
          pathname: backLink,
          search: backLinkState ? undefined : window.location.search,
        },
        { state: backLinkState }
      );
    } else {
      navigate(-1);
    }
  };
  
  const handleImportClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (extralink && extralink.trim() !== "") {
      navigate(
        {
          pathname: extralink,
          // search: backLinkState ? undefined : window.location.search,
        }
        // { state: backLinkState }
      );
    } else {
      navigate(-1);
    }
  };
  // const handleImportClick = (e: React.MouseEvent) => {
  //   e.preventDefault();
  //   if (onClick) {
  //     onClick(e);
  //   }
  // };
  const linkTo: To =
    link && link.trim() !== ""
      ? {
          pathname: link,
          search: linkState ? undefined : window.location.search,
        }
      : "#";
  const backLinkTo: To =
    backLink && backLink.trim() !== ""
      ? {
          pathname: backLink,
          search: backLinkState ? undefined : window.location.search,
        }
      : "#";

  return (
    <div className={containerClass}>
      <div
        className={`content ${
          (basePath === "RepList" ||
            basePath === "company" ||
            basePath === "V-10001" ||
            basePath === "order" ||
            basePath === "receipt") &&
          "mt-3"
        }`}
      >
        <div className={`page-header ${basePath === "RepOpt" && "d-lg-none"}`}>
          <div className="add-item d-flex">
            <div className="page-title">
              {header && header.trim() !== "" && <h4>{header}</h4>}
              {subHeader && subHeader.trim() !== "" && (
                <h6 style={subheaderstyle}>{subHeader}</h6>
              )}
            </div>
          </div>
          <ul className="table-top-head" role="toolbar">
            {hasGridTable && ExportR === 1 && (
              <>
                <li>
                  <OverlayTrigger placement="top" overlay={renderTooltip}>
                    <Link to={pdfLink || "#"} onClick={handleExportPDF}>
                      <ImageWithBasePath
                        src="assets/img/icons/pdf.svg"
                        alt="img"
                      />
                    </Link>
                  </OverlayTrigger>
                </li>
                {pathName !== "/RepList/R-10077" &&
                  pathName !== "/RepList/R-10078" && (
                    <li>
                      <OverlayTrigger
                        placement="top"
                        overlay={renderExcelTooltip}
                      >
                        <Link
                          to="#"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          onClick={handleExportCSV}
                        >
                          <ImageWithBasePath
                            src="assets/img/icons/excel.svg"
                            alt="img"
                          />
                        </Link>
                      </OverlayTrigger>
                    </li>
                  )}
              </>
            )}
            {basePath === "V-10001" &&
              ExportR === 1 &&
              pdfLink &&
              pdfLink.trim() !== "" && (
                <li>
                  <OverlayTrigger placement="top" overlay={renderTooltip}>
                    <Link to={pdfLink || "#"} onClick={handleExportPDF}>
                      <ImageWithBasePath
                        src="assets/img/icons/pdf.svg"
                        alt="img"
                      />
                    </Link>
                  </OverlayTrigger>
                </li>
              )}
            <div className="page-btn">
              <li>
                {addButton && addButton.trim() !== "" && (
                  <Link
                    to={linkTo}
                    state={linkState}
                    {...props}
                    className="btn btn-added"
                    onClick={handleClick}
                    aria-label={`Add ${addButton}`}
                  >
                    <PlusCircle className="me-2" aria-hidden="true" />
                    {addButton}
                  </Link>
                )}
                {backButtonName && backButtonName.trim() !== "" && (
                  <Link
                    to={backLinkTo}
                    state={backLinkState}
                    className="btn btn-secondary"
                    onClick={handleBackClick}
                  >
                    <ArrowLeft className="me-2" />
                    {backButtonName}
                  </Link>
                )}
              </li>
            </div>
            <div className="page-btn import">
              {importButtonName && importButtonName.trim() !== "" && (
                <Link
                  to={extralink ?? "#"}
                  className="btn btn-added color"
                  onClick={handleImportClick}
                  // aria-label={`${importButtonName}`}
                >
                  <PlusCircle className="me-2" />
                  {importButtonName}
                </Link>
              )}
            </div>
          </ul>
        </div>
        {React.Children.map(children, (child) => {
          if (
            (React.isValidElement(child) && child.type === GridTable) ||
            (React.isValidElement(child) && child.type === StockReportTable)
          ) {
            console.log("Assigning ref to:", child.type.name);
            return React.cloneElement(child as ReactElement<GridTableProps>, {
              ref: tableRef,
            });
          }
          return child;
        })}
      </div>
    </div>
  );
};

export default memo(Wrapper);
